module.exports = __webpack_public_path__ + "static/img/15.3fdb6f89.jpg";